import { jsx as _jsx } from "react/jsx-runtime";
import { Divider as MuiDivider, Box } from '@mui/material';
const Divider = ({ style, color, thickness, margin, limitToPageWidth, }) => (_jsx(Box, { sx: {
        ...(limitToPageWidth && {
            maxWidth: 1200,
            marginX: 'auto',
            width: '100%',
        }),
    }, children: _jsx(MuiDivider, { sx: [
            style === 'rounded'
                ? {
                    borderTop: `${thickness / 2}px solid red`,
                    borderBottom: `${thickness / 2}px solid green`,
                    borderRadius: `${thickness / 2}px`,
                    borderColor: color,
                }
                : {
                    borderTop: `${thickness}px ${style} green`,
                    borderBottom: 0,
                    borderColor: color,
                },
            margin ? {
                marginLeft: `${margin.left || 0}px`,
                marginRight: `${margin.right || 0}px`,
                marginTop: `${margin.top || 0}px`,
                marginBottom: `${margin.bottom || 0}px`,
            } : {},
        ] }) }));
Divider.meta = {
    group: 'design',
    name: 'Divider',
    sort: 70,
    description: 'Horizontal divider to seperate content.',
    props: [
        {
            key: 'thickness',
            name: 'Thickness',
            type: 'number',
            min: 0,
            max: 20,
            description: 'Thickness of the divider.',
        },
        {
            key: 'style',
            name: 'Style',
            type: 'select',
            values: ['dashed', 'dotted', 'solid', 'rounded'],
            labels: ['Dashed', 'Dotted', 'Solid', 'Rounded'],
        },
        {
            key: 'limitToPageWidth',
            name: 'Limit Width',
            type: 'boolean',
            description: 'Limit the width of the stack to the maximum page width',
            group: 'style',
        },
        {
            key: 'color',
            name: 'Color',
            type: 'color',
            group: 'style',
        },
        {
            key: 'margin',
            name: 'Margin',
            type: 'margin',
            min: -20,
            max: 20,
            description: 'Adds space around the divider.',
            group: 'style',
        },
    ],
    defaultConfig: {
        type: 'component',
        component: 'Divider',
        props: {
            limitToPageWidth: true,
            margin: {
                enabled: true,
                top: 10,
                bottom: 10,
                left: 2,
                right: 2,
            },
            thickness: 4,
            style: 'solid',
            color: '#000000',
        },
    },
};
export default Divider;
//# sourceMappingURL=Divider.js.map